import { CoreAppState } from '../state/core-app.state';
import { BaseResourceService } from './base-resource.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { PushNotificationToken } from '@prisma/client';
import { PushNotificationTokenResourceTypeMappings } from '@aa/nest/resource';
import { pushNotificationTokenCompositeKeyOrder } from '@aa/nest/resource/objects';

@Injectable()
export class PushNotificationTokenService extends BaseResourceService<PushNotificationTokenResourceTypeMappings> {
  constructor(
    protected override readonly http: HttpClient,
    protected override readonly store: Store<CoreAppState>,
  ) {
    super(http, store, 'push-notification-tokens');
  }
}
